import * as NextConstants from "../../../src/constants/next"
import React from "react"
import { Row } from "react-bootstrap"
import { GuidesListPage } from "@components/Guides/GuidesListPage"
import { SEO } from "../../../src/types/next.js"
import { GuidesAPI } from "../../../src/apis/GuidesAPI"
import Pagination from "@components/UI/Pagination"
import { getGuidesPaginatedPageUrl } from "../../../src/utils/urls"
import InferNextPropsType from "infer-next-props-type"
import { GUIDES_PAGE_SIZE } from "../../../src/constants/apis"
import { getNavigationProps } from "@components/Navigation/getNavigationProps"

export default function GuidesTypePage({ guides, pages, pageNum }: InferNextPropsType<typeof getStaticProps>) {
  return (
    <>
      <GuidesListPage guides={guides!} />
      <Row className={"page-desktop-row page-mobilegit-row"}>
        <Pagination
          page={pageNum!}
          pageCount={pages!}
          onChange={(page) => {
            return `${getGuidesPaginatedPageUrl(page)}`
          }}
        />
      </Row>
    </>
  )
}

export async function getStaticProps() {
  const title = `Le migliori guide per le scommesse per il calcio`

  const seo: SEO = {
    description: `Scopri le migliori guide per le scommesse per il calcio, i bonus e le migliori quote per piazzare le tue puntate in sicurezza.`,
    keywords: ["Guide"],
    canonicals: [`/scommesse/guide`],
    index: true,
    follow: true,
  }

  const [navigationProps, { data, pages }] = await Promise.all([
    getNavigationProps(),
    GuidesAPI.getPaginated({
      pageSize: GUIDES_PAGE_SIZE,
      currentPage: 1,
    }),
  ])

  return {
    props: {
      isGuidePage: false,
      pageNum: 1,
      title,
      seo,
      guides: data,
      pages,
      next: "/scommesse/guide/2",
      navigationProps,
    },
    revalidate: NextConstants.REVALIDATE,
  }
}
